export const BOUNDARY_CREATE_OPTIMIZED_ADD_ITEM = 'BOUNDARY_CREATE_OPTIMIZED_ADD_ITEM';
export const BOUNDARY_CREATE_OPTIMIZED_REMOVE_ITEM = 'BOUNDARY_CREATE_OPTIMIZED_REMOVE_ITEM';
export const BOUNDARY_CREATE_OPTIMIZED_UPDATE_ITEM = 'BOUNDARY_CREATE_OPTIMIZED_UPDATE_ITEM';
